import { useEffect } from 'react';

/**
 * Lightweight scroll-reveal: scans for [data-reveal] elements
 * and adds .is-visible when they enter viewport.
 * No external dependencies.
 */
export default function useScrollReveal() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (!('IntersectionObserver' in window)) return;

    const elements = document.querySelectorAll('[data-reveal]:not(.is-visible)');
    if (elements.length === 0) return;

    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
    );

    elements.forEach((el) => obs.observe(el));
    return () => obs.disconnect();
  });
}
